import { ListItem } from "@mui/material";
import { ReactElement } from "react";

import LoadingCircle from "../../loadingCircle/LoadingCircle";
import "./DeliveryAction.scss";

interface DeliveryActionProps {
  icon: ReactElement;
  label: string;
  onClick: () => void;
  isLoading?: boolean;
}
const DeliveryAction = (props: DeliveryActionProps) => {
  const { icon, label, onClick, isLoading } = props;

  return (
    <ListItem className="option" onClick={onClick}>
      <div className="option-icon">{icon}</div>
      <div className="option-label">
        {label}
        {isLoading && <LoadingCircle className="ml-10" size={16} />}
      </div>
    </ListItem>
  );
};
export default DeliveryAction;
